import { createSelector } from 'reselect'
import getMessageErrorUtil from 'utils/error/get-message'
import { getObjectUtil } from 'packages/src'

function getErrorReduxSelector (path) {
  return createSelector(
    state => getObjectUtil(state, `${path}.error`),
    error => {
      if (!error) {
        return
      }
      return getMessageErrorUtil(error)
    }
  )
}

export default getErrorReduxSelector
